import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";

import rv1 from "../../images/review/img-1.jpg";
import rv2 from "../../images/review/img-2.jpg";
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";

const ProductTabs = (props) => {
  const [activeTab, setActiveTab] = useState("1");
  const { t } = useTranslation();
  const { lang } = useLang();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <div className="row">
      <div className="col col-xs-12">
        <div className="product-info">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => {
                  toggle("1");
                }}
              >
                {t(`description`)}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle("2");
                }}
              >
                {t(`review`)}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col sm="12">
                  <div id="Schedule">
                    <p>{t(`review1`)}</p>
                    <p>{t(`review2`)}</p>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <div className="row">
                <div className="col col-lg-10 col-12">
                  <div className="client-rv">
                    <div className="client-pic">
                      <img src={rv1} alt="" />
                    </div>
                    <div className="details">
                      <div className="name-rating-time">
                        <div className="name-rating">
                          <div>
                            <h4>
                              {lang === "ar" ? "محمد علي" : "Mohammed Ali"}
                            </h4>
                          </div>
                          <div className="product-rt">
                            <span>
                              {lang === "ar" ? "28 سبتمبر 2021" : "28 Sep 2021"}
                            </span>
                            <div className="rating">
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star-o"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="review-body">
                        <p>{t(`review3`)}</p>
                      </div>
                    </div>
                  </div>
                  <div className="client-rv">
                    <div className="client-pic">
                      <img src={rv2} alt="" />
                    </div>
                    <div className="details">
                      <div className="name-rating-time">
                        <div className="name-rating">
                          <div>
                            <h4>
                              {lang === "ar"
                                ? "محمود المنسي "
                                : "Mahmoud Mansy"}
                            </h4>
                          </div>
                          <div className="product-rt">
                            <span>
                              {lang === "ar" ? "28 سبتمبر 2021" : "28 Sep 2021"}
                            </span>
                            <div className="rating">
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star"></i>
                              <i className="fa fa-star-o"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="review-body">
                        <p>{t(`review1`)}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col col-lg-12 col-12 review-form-wrapper">
                  <div className="review-form">
                    <h4>{t(`addReview`)}</h4>
                    <p>{t(`emailRequired`)}</p>
                    <form onSubmit={SubmitHandler}>
                      <div className="give-rat-sec">
                        <p>{t(`yourRating`)}</p>
                        <div className="give-rating">
                          <label>
                            <input type="radio" name="stars" value="1" />
                            <span className="icon">★</span>
                          </label>
                          <label>
                            <input type="radio" name="stars" value="2" />
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                          </label>
                          <label>
                            <input type="radio" name="stars" value="3" />
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                          </label>
                          <label>
                            <input type="radio" name="stars" value="4" />
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                          </label>
                          <label>
                            <input type="radio" name="stars" value="5" />
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                            <span className="icon">★</span>
                          </label>
                        </div>
                      </div>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t(`name`)}
                          required
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          className="form-control"
                          placeholder={t(`email`)}
                          required
                        />
                      </div>
                      <div>
                        <textarea
                          className="form-control"
                          placeholder={t(`review`)}
                        ></textarea>
                      </div>
                      <div className="rating-wrapper">
                        <div className="submit">
                          <button type="submit" className="theme-btn">
                            {t(`postReview`)}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default ProductTabs;
